import { firebase } from '../config/configureFirebase';

export const callBookingTransaction = async (functionName, payload) => {
  const { auth, config } = firebase;
  if (!auth || !auth.currentUser) {
    throw new Error('Authentication is required.');
  }
  if (!config || !config.projectId) {
    throw new Error('Firebase projectId is required.');
  }
  const token = await auth.currentUser.getIdToken();
  const fallbackUrl = `https://us-central1-${config.projectId}.cloudfunctions.net/${functionName}`;
  const response = await fetch(firebase.functionUrl ? firebase.functionUrl(functionName) : fallbackUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(payload || {})
  });
  let result = {};
  try {
    result = await response.json();
  } catch (error) {
    throw new Error('Invalid response from the booking transaction service.');
  }
  if (!response.ok || result.error) {
    throw new Error(result.error || 'Booking transaction failed.');
  }
  return result;
};
